import { useState, useEffect, Fragment } from "react";
import { Box, Button, Typography, Grid, Stack } from "@mui/material";
import { Link, useNavigate, useParams,useOutletContext } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import MpgInput from "../../../../../CommonFormComp/MpgInput";
import MpgItem from "../../../../../CommonFormComp/MpgItem";
import MpgCheckbox from "../../../../../CommonFormComp/MpgCheckbox";
import { editThoughtLeadershipValidation } from "./editThoughtLeadershipValidation";
import { useGetClientAccountDropdownMutation } from "../../../../../reactQueries/AppApi/rqHooksForClientUsers"
import CircularProgress from '@mui/material/CircularProgress';
import MpgClientAccountTransferListDialog from "../../../../../CommonFormComp/MpgClientAccountTransferList/MpgClientAccountTransferListDialog";
import { useUpdateThoughtLeadershipResourcesBySitecoreIdMutation } from "../../../../../reactQueries/AppApi/rqHooksForThoughtLeadershipResources"
import { thoughtLeadershipResourceViewPath } from "../../../../../routes/routePaths";
import MpgErrorDialog from "../../../../../common/dialog/MpgErrorDialog";
import MpgLoadingDialog from "../../../../../common/dialog/MpgLoadingDialog";
import { useGetLoggedInUserDetails } from "../../../../../hooksAndFunctions/customHooks/useGetLoggedInUserDetails";
import { getAccessTypes } from "../../../../../hooksAndFunctions/functions/getAccessTypes";
import { useGetAccountAndSubAccListOnlyForA4Role } from "../../../../../hooksAndFunctions/customHooks/useGetAccountAndSubAccListOnlyForA4Role";

const EditThoughtLeadershipResources = ({ thoughtLeadershipResourcesDataBySitecoreId }) => {
  const {refClientSpecificCmsData}=useOutletContext();
  const { loggedInUser } = useGetLoggedInUserDetails();
  const { clientPortalAdminRoleId, isEnterpriseAdmin, id: userId } = loggedInUser;

  const {
    clientPortalAdminType
  } = getAccessTypes()
  const {
    hasA2Access,
    hasA4Access
  } = clientPortalAdminType

  const navigate = useNavigate()

  const { sitecoreId } = useParams()
  const userName = JSON.parse(window.sessionStorage.getItem('UserAccount'))?.["name"];

  /** !!!!!!! from handling !!!!!! */
  const { schema } = editThoughtLeadershipValidation()

  const rhfFormInstance = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      resource_title: thoughtLeadershipResourcesDataBySitecoreId?.Title || "",
      sitecore_id: thoughtLeadershipResourcesDataBySitecoreId?.SitecoreId || "",
      resource_type: thoughtLeadershipResourcesDataBySitecoreId?.ResourceType || "",
      languages: thoughtLeadershipResourcesDataBySitecoreId?.Languages || "",
      available_to_all: !!thoughtLeadershipResourcesDataBySitecoreId?.IsAvailableToAll ? true : false,

    }
  });
  const { setValue, handleSubmit, watch } = rhfFormInstance

  /** !!!!!!! dialog state handling !!!!!! */
  const [openClientAccountDialog, setOpenClientAccountDialog] = useState(false);

  /** !!!!!!! API calls !!!!!! */

  const { mutate: updateTLR, isError: isErrorOnUpdateTLR, isLoading: isLoadingOnUpdateTLR, isSuccess: isSuccessOnUpdateTLR } = useUpdateThoughtLeadershipResourcesBySitecoreIdMutation()

  /**useful for only A2 A4 role */
  const { clientAccountIdListForA4Role } = useGetAccountAndSubAccListOnlyForA4Role({ userId });
  // api - get client accounts list
  const { mutate: getClientAccountList,
    data: clientAccountList,
    isLoading: isLoadingOnClientUserData } = useGetClientAccountDropdownMutation();

  useEffect(() => {
    getClientAccountList({ loggedInUserId: userId, roleId: clientPortalAdminRoleId, isEnterpriseAdmin })
  }, [loggedInUser])

  const clientAccountData = clientAccountList?.data && clientAccountList?.data?.map((item) =>{
    const disableOptionForA2A4Role = !clientAccountIdListForA4Role?.includes(item?.Id);
    let disableOption = false

    /**disable option is client sub acc is Inactive */
    if (!item.IsActive) {
      disableOption = true
    } else {
      /**(only for A4 role) get all clinet sub acc ids where this user is not A4 admin and diable those autocomplete options */
      if ((!!hasA4Access || !!hasA2Access) && !!disableOptionForA2A4Role) {
        disableOption = true
      }
    }

    return {
      ...item,
      disableOption
    }
  })


  /** !!!!!!! handling exluded client account list !!!!!! */
  /**
   * {
   * Id:"00000000000",
   * ClientAccountName:"abc"
   * }
   */
  const [excludedClientAccList, setExcludedClientAccList] = useState([])
  /**setting selected values */
  useEffect(() => {
    if (!!excludedClientAccList && excludedClientAccList.length) {
      const list = !!excludedClientAccList && excludedClientAccList.map((item) => {
        return item.ClientAccountName
      })
      setValue('excluded_client_accounts', list.toString(), { shouldValidate: true })
    } else {
      setValue('excluded_client_accounts', "")
    }
  }, [excludedClientAccList])

  /**checking existing client accounts */
  useEffect(() => {
    if (!!thoughtLeadershipResourcesDataBySitecoreId && !!thoughtLeadershipResourcesDataBySitecoreId.thoughtLeadershipResourcesExcludedAccounts) {

      let clientAccList = []
      let clientAccOnLyNameList = []
      thoughtLeadershipResourcesDataBySitecoreId.thoughtLeadershipResourcesExcludedAccounts.forEach((item) => {
        clientAccList.push({
          Id: item.ClientAccountId,
          ClientAccountName: item.ClientAccountName,
        })
        clientAccOnLyNameList.push(item.ClientAccountName)
      })

      setValue('excluded_client_accounts', clientAccOnLyNameList.toString(), { shouldValidate: true })

      setExcludedClientAccList(clientAccList)

    }
  }, [thoughtLeadershipResourcesDataBySitecoreId])

  /** !!!!!!!! handling submit function !!!!!!!!! */
  const submitFormDataHandler = (data, buttonType) => {

    //on unpublished it should be false and on submit it should be true
    const status = buttonType === "submit" ? true : false;

    let isAvailableToAll = true
    if (!excludedClientAccList.length && !data.available_to_all) {
      /**if no excluded client present and  isAvailableToAll checkbox is false then by default we need to send isAvailableToAll=true to DB*/
      isAvailableToAll = true
    } else {
      /**otherwise take value from checkbox for isAvailableToAll*/
      isAvailableToAll = data.available_to_all
    }

    let excludedClientAccountList = []
    if (!!excludedClientAccList && excludedClientAccList.length) {
      excludedClientAccList.forEach((item) => {
        excludedClientAccountList.push({
          ClientAccountId: item.Id
        })
      })
    }

    const body = {
      IsAvailableToAll: isAvailableToAll,
      thoughtLeadershipResourcesExcludedAccounts: excludedClientAccountList || [],
      SitecoreId: data.sitecore_id || "",
      Status: status, //on unpublished it should be false
      UpdatedBy: userName
    }
    // console.log("sub-data", body);

    updateTLR({ body })
  };

  useEffect(() => {
    if (!!isSuccessOnUpdateTLR) {
      navigate(thoughtLeadershipResourceViewPath)
    }
  }, [isSuccessOnUpdateTLR])

  const availableToAll = watch("available_to_all")
  const excludedClientAccounts = watch("excluded_client_accounts")

  /**managing mutually exclusive states */
  useEffect(() => {
    if (!!excludedClientAccounts) {
      setValue('available_to_all', false)
    }
    if (!!availableToAll) {
      setValue('excluded_client_accounts', "")
      setExcludedClientAccList([])
    }
  }, [excludedClientAccounts, availableToAll])

  const fetchThoughtLeadershipDetailsCMSLabel=(key)=>{
    if(refClientSpecificCmsData?.Components && refClientSpecificCmsData?.Components["ThoughtLeadershipDetails"]){
       const ThoughtLeadershipDetailsLabel=refClientSpecificCmsData?.Components["ThoughtLeadershipDetails"];
          return returnLabel(ThoughtLeadershipDetailsLabel?.Labels, key)
    }
    return '';
}

const fetchCommonComponentCMSLabel=(key)=>{
  if(refClientSpecificCmsData?.Components && refClientSpecificCmsData?.Components["CommonComponent"]){
     const clientSubAccountGroupsListCMSDataLabel=refClientSpecificCmsData?.Components["CommonComponent"];
        return returnLabel(clientSubAccountGroupsListCMSDataLabel?.Labels, key)
  }
  return '';
}

const returnLabel = (labelArray=[], key) => {
      return labelArray.find((x) => x.Key === key)?.Phrase || '';
}

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Typography variant="h5" align="center" sx={{ fontWeight: "bolder" }}>
         {refClientSpecificCmsData?.Components && refClientSpecificCmsData?.Components["ThoughtLeadershipDetails"]?.Title}
        </Typography>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems="center"
          spacing={1}
          m={1}
        >
          <Button
            variant="outlined"
            size="small"
            component={Link}
            to={thoughtLeadershipResourceViewPath}
          >
            {fetchThoughtLeadershipDetailsCMSLabel("ThoughtLeadershipDetails.ThoughtLeaderships")}
          </Button>
        </Stack>

        <Box
          component="form"
          noValidate
          autoComplete="off"
        // onSubmit={handleSubmit(onSubmit)}
        >
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6}>
              <MpgItem sx={{ padding: { xs: "20px" } }}>
                <Typography
                  variant="h6"
                  align="center"
                  sx={{ fontWeight: "bolder" }}
                >
                 {fetchThoughtLeadershipDetailsCMSLabel("ThoughtLeadershipDetails.ClientUserDetails")}
                </Typography>
                <MpgInput
                  rhfFormInstance={rhfFormInstance}
                  name={"resource_title"}
                  label={fetchThoughtLeadershipDetailsCMSLabel("ThoughtLeadershipDetails.ResourceTitle")}
                  multiline
                  disabled
                  fullWidth
                />
                <MpgInput
                  rhfFormInstance={rhfFormInstance}
                  name={"sitecore_id"}
                  label={fetchThoughtLeadershipDetailsCMSLabel("ThoughtLeadershipDetails.SitecoreId")}
                  multiline
                  disabled
                  fullWidth
                />
                <MpgInput
                  rhfFormInstance={rhfFormInstance}
                  name={"resource_type"}
                  label={fetchThoughtLeadershipDetailsCMSLabel("ThoughtLeadershipDetails.ResourceType")}
                  multiline
                  disabled
                  fullWidth
                />
                <MpgInput
                  rhfFormInstance={rhfFormInstance}
                  name={"languages"}
                  label={fetchThoughtLeadershipDetailsCMSLabel("ThoughtLeadershipDetails.Languages")}
                  multiline
                  rows={4}
                  disabled
                  fullWidth
                />
              </MpgItem>
            </Grid>
            <Grid item xs={12} sm={6}>
              <MpgItem sx={{ padding: { xs: "20px" } }}>
                <Typography
                  variant="h6"
                  align="center"
                  sx={{ fontWeight: "bolder" }}
                >
                  {fetchThoughtLeadershipDetailsCMSLabel("ThoughtLeadershipDetails.AvailableResources")}
                </Typography>

                <MpgCheckbox
                  rhfFormInstance={rhfFormInstance}
                  name={"available_to_all"}
                  label={"Available To All"}
                  persistantMsg={fetchThoughtLeadershipDetailsCMSLabel("ThoughtLeadershipDetails.Notes")}
                />

                <div>
                  <MpgInput
                    rhfFormInstance={rhfFormInstance}
                    label={fetchThoughtLeadershipDetailsCMSLabel("ThoughtLeadershipDetails.ExcludedClientAccounts")}
                    name={'excluded_client_accounts'}
                    multiline
                    rows={4}
                    fullWidth
                    disabled={true}
                  />
                  <Button
                    onClick={() => { setOpenClientAccountDialog(true) }}
                    disabled={!!isLoadingOnClientUserData || !!availableToAll}
                  >
                    {
                      !!isLoadingOnClientUserData ? (
                        <Fragment>
                          <CircularProgress
                            size={15}
                            sx={{ margin: '5px' }}
                          />
                          {fetchCommonComponentCMSLabel("Common.Fetching")}
                        </Fragment>
                      ) : (
                        <Fragment> {fetchThoughtLeadershipDetailsCMSLabel("ThoughtLeadershipDetails.ExcludedClient")}</Fragment>
                      )
                    }
                  </Button>

                </div>
              </MpgItem>
            </Grid>
          </Grid>
        </Box>

        {/** when we have mutiple buttons on single submit then keep all submit type buttons outside of form comp and comment onSubmit method of form*/}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent={"space-evenly"}
          mt={3}
        >
          <Button
            variant="outlined"
            size="small"
            // type="submit"
            onClick={handleSubmit((data) => submitFormDataHandler(data, 'submit'))}
            //disabled={!!hasA4Access}
          >
            {fetchThoughtLeadershipDetailsCMSLabel("ThoughtLeadershipDetails.Submit")}
          </Button>

          <Button
            variant="outlined"
            size="small"
            // type="submit"
            onClick={handleSubmit((data) => submitFormDataHandler(data, 'unpublish'))}
            //disabled={!!hasA4Access}
          >
             {fetchThoughtLeadershipDetailsCMSLabel("ThoughtLeadershipDetails.UnPublish")}
          </Button>
        </Stack>

        <MpgClientAccountTransferListDialog
          open={openClientAccountDialog}
          setOpen={setOpenClientAccountDialog}

          transferDialogTitle={fetchThoughtLeadershipDetailsCMSLabel("ThoughtLeadershipDetails.ExcludedClient")}
          leftTableTitle={fetchThoughtLeadershipDetailsCMSLabel("ThoughtLeadershipDetails.AvailableClientAccounts")}
          rightTableTitle={fetchThoughtLeadershipDetailsCMSLabel("ThoughtLeadershipDetails.ExcludedClientAccounts")}
          
          grabRightTableData={setExcludedClientAccList}

          leftTableDataToPop={clientAccountData || []}
          rightTableDataToPop={excludedClientAccList}
          cmsData={refClientSpecificCmsData?.Components && refClientSpecificCmsData}
        />

        {/** error dialog on update action */}
        <MpgErrorDialog
          open={!!isErrorOnUpdateTLR}
        />
        <MpgLoadingDialog
          open={
            !!isLoadingOnUpdateTLR
          }
        />
      </Box>
    </>
  );
};

export default EditThoughtLeadershipResources;
